<template>
  <div class="position-relative">
    <BaseTopLine> </BaseTopLine>

    <!-- новая разметка -->
    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-text-white"
    >
      <div
        class="tw-flex tw-justify-between tw-items-end tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-[#E7EAF2] tw-pb-[10px]"
      >
        <div class="tw-flex tw-items-end tw-gap-[20px] tw-max-w-[800px]">
          <div class="tw-app-input-container">
            <label class="tw-app-input-container-label">
              {{ dataLang["reg_fin_text_2"] }}
            </label>
            <div class="tw-flex tw-gap-[10px] tw-items-center">
              <BaseDatePicker
                class="tw-bg-white !tw-text-white tw-bg-opacity-[15%] tw-rounded-[3px] [&_i]:!tw-text-white tw-w-full"
                input-class="tw-app-input-dark !tw-bg-transparent"
                v-model="selectTimeTopFilter.dateCreatedStart"
                type="date"
                :clearable="false"
                lang="ru"
                id="finreestr__created_at"
                style="width: 120px"
                value-type="format"
                :format="`DD.MM.YYYY`"
              >
              </BaseDatePicker>
              —
              <BaseDatePicker
                class="tw-bg-white !tw-text-white tw-bg-opacity-[15%] tw-rounded-[3px] [&_i]:!tw-text-white tw-w-full"
                input-class="tw-app-input-dark !tw-bg-transparent"
                v-model="selectTimeTopFilter.dateCreatedEnd"
                type="date"
                lang="ru"
                :clearable="false"
                id="finreestr__created_at"
                style="width: 120px"
                value-type="format"
                :format="`DD.MM.YYYY`"
                :disabled-date="disabledFutureDates"
              >
              </BaseDatePicker>
            </div>
          </div>

          <div class="tw-app-input-container">
            <label class="tw-app-input-container-label">
              {{ dataLang["reg_fin_text_3"] }}
            </label>
            <BaseInputNew
              @keyupEnter="getWithFilter()"
              inputClass="tw-app-input-dark"
              :inputStyle="{ width: '100%' }"
              :additionalParams="{ type: 'input' }"
              @input="fillFilter"
              inputName="finreestr__id"
            />
          </div>

          <div class="tw-flex">
            <button
              type="button"
              class="tw-app-btn-primary"
              @click="(searchType = false), loadData()"
            >
              {{ dataLang["reg_fin_text_4"] }}
            </button>
            <button type="button" class="tw-app-btn-light" @click="resetFilter">
              {{ dataLang["reg_fin_text_5"] }}
            </button>
          </div>
        </div>
        <div ref="topFilter">
          <div
            class="tw-flex tw-items-center tw-gap-[10px]"
            v-if="aboutPageInfo"
          >
            {{ dataLang["reg_fin_text_6"] }}
            <div class="tw-app-btn-primary !tw-bg-[#23b14d] !tw-no-underline">
              {{ aboutPageInfo.sumReceipts?.split(".")?.join(",") }}
            </div>
            {{ dataLang["reg_fin_text_7"] }}
            <div class="tw-app-btn-primary !tw-bg-[#ff2400] !tw-no-underline">
              -{{ aboutPageInfo.sumExpenses?.split(".")?.join(",") }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="tw-flex tw-gap-[15px] tw-mt-[10px]"
        v-if="Object.values(foundsList).length"
      >
        <FirstColumn :options="optionsFirstCol" />
        <div class="tw-min-w-[1px] tw-bg-forLine"></div>
        <SecondColumn :options="optionsTwoCol" />
        <div class="tw-min-w-[1px] tw-bg-forLine"></div>
        <SecondColumn :options="optionsThreeCol" />
        <div class="tw-min-w-[1px] tw-bg-forLine"></div>
        <SecondColumn :options="optionsFourCol" />
        <div class="tw-min-w-[1px] tw-bg-forLine"></div>
        <SecondColumn :options="optionsFiveCol" />
        <div class="tw-min-w-[1px] tw-bg-forLine"></div>
        <div class="tw-flex tw-flex-col tw-justify-center tw-px-[15px]">
          <div class="tw-mb-[10px]">{{ dataLang["reg_fin_text_33"] }}</div>
          <div class="tw-text-[18px]">{{ fullSum?.split(".")?.join(",") }}</div>
        </div>
      </div>
    </div>

    <div
      class="tw-flex tw-items-center tw-justify-end tw-gap-[10px] tw-mt-[15px] tw-mx-[26px] tw-text-forText tw-text-[12px]"
    >
      <div class="first-letter:tw-capitalize">
        {{ dataLang["reg_fin_text_39"] }}
      </div>
      <div
        class="tw-bg-main2 tw-w-[24px] tw-h-[24px] tw-border-forLine tw-border-solid tw-border-[1px] tw-flex tw-rounded-[3px] tw-items-center tw-justify-center"
      >
        <img :src="require(`@/assets/icons/minus-red.svg`)" width="7" />
      </div>
      <div>{{ dataLang["reg_fin_text_40"] }}</div>
    </div>

    <div class="tw-flex tw-gap-[10px] tw-my-[10px] tw-mx-[26px]">
      <button
        class="tw-app-btn-success"
        @click="
          $modal.show('toMoveCost', {
            type: 'clientPayment',
          })
        "
      >
        <img :src="require(`@/assets/icons/addwhite.svg`)" width="13.5" />
        {{ dataLang["reg_fin_text_62"] }}
      </button>
      <button
        class="tw-app-btn-success"
        @click="
          $modal.show('toMoveCost', {
            type: 'coming',
          })
        "
      >
        <img :src="require(`@/assets/icons/addwhite.svg`)" width="13.5" />
        {{ dataLang["reg_fin_text_35"] }}
      </button>
      <button
        class="tw-app-btn-info"
        @click="
          $modal.show('toMoveCost', {
            type: 'transit',
          })
        "
      >
        <img :src="require(`@/assets/icons/moving.svg`)" width="13.5" />
        {{ dataLang["reg_fin_text_36"] }}
      </button>
      <button
        class="tw-app-btn-primary-outline tw-app-btn-lock"
        @click="
          () => {
            activeSelectRowsMultiple.length
              ? $modal.show('pincode', { typeOfnew: 'delete' })
              : $toast.error('Выберите запись');
            typePin = 'delete';
          }
        "
      >
        <img :src="require(`@/assets/icons/adddel.svg`)" width="13.5" />
        {{ dataLang["reg_fin_text_37"] }}
      </button>
      <button
        class="tw-app-btn-primary-outline tw-app-btn-lock"
        @click="
          () => {
            $modal.show('pincode');
            typePin = 'exel';
          }
        "
      >
        <img :src="require(`@/assets/icons/xls-file.svg`)" width="14" />
        {{ dataLang["reg_fin_text_38"] }}
      </button>
      <button class="tw-app-btn-warning" @click="$modal.show('onAddBalance')">
        Пополнить баланс
      </button>
      <button class="tw-app-btn-primary-outline" @click="loadFile">
        Фин директива XLS
      </button>
    </div>
    <!-- новая разметка -->

    <!-- <div
      class="py-10 px-15 d-flex gap-5 align-items-center justify-content-between border-top fsc-9 fsc-bxl-14 bg-system-secondary"
      v-if="Object.values(foundsList).length"
    >
      <div class="pe-10 flex-grow-1 ps-15 border-end border-disabled">
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          {{ dataLang[foundsList.fund_3?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_3.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--move"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_3,
                  type: 'transit',
                })
              "
            >
              <img
                :src="require(`@/assets/icons/moving.svg`)"
                width="8.5"
                height="9.75"
              />
            </div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          {{ dataLang[foundsList.fund_2?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_2.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--move"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_2,
                  type: 'transit',
                })
              "
            >
              <img
                :src="require(`@/assets/icons/moving.svg`)"
                width="8.5"
                height="9.75"
              />
            </div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-start wp-100"
        >
          <div v-if="dataLang[foundsList.fund_custom_1?.finreestr_funds__name]">
            {{ dataLang[foundsList.fund_custom_1?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_1?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_1.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--move"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_1,
                  type: 'transit',
                })
              "
            >
              <img
                :src="require(`@/assets/icons/moving.svg`)"
                width="8.5"
                height="9.75"
              />
            </div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-start wp-100"
        >
          <div v-if="dataLang[foundsList.fund_custom_2?.finreestr_funds__name]">
            {{ dataLang[foundsList.fund_custom_2?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_2?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_2.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--move"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_2,
                  type: 'transit',
                })
              "
            >
              <img
                :src="require(`@/assets/icons/moving.svg`)"
                width="8.5"
                height="9.75"
              />
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-start wp-100">
          {{ dataLang[foundsList.fund_1?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_1.finreestr_funds__amount }}
            </div>
            <div class="d-flex gap-5">
              <div
                class="payload-button payload-button--top"
                @click="$modal.show('withdrawalOfFundsModal')"
              >
                <img
                  :src="require(`@/assets/icons/toTop.svg`)"
                  width="8.5"
                  height="9.75"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pe-10 flex-grow-1 ps-15 border-end border-disabled">
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          {{ dataLang[foundsList.fund_4?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_4.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_4,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-start wp-100"
        >
          {{ dataLang[foundsList.fund_5?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_5.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_5,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          {{ dataLang[foundsList.fund_6?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_6.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('assigneUserSpend', {
                  datas: foundsList.fund_6,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="d-flex mb-10 justify-content-between align-items-center wp-100"
        >
          {{ dataLang[foundsList.fund_7?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_7.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_7,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center wp-100">
          {{ dataLang[foundsList.fund_8?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_8.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_8,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
      </div>
      <div class="pe-10 flex-grow-1 ps-15 border-end border-disabled">
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          {{ dataLang[foundsList.fund_9?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_9.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_9,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          {{ dataLang[foundsList.fund_10?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_10.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_10,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          {{ dataLang[foundsList.fund_11?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_11.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_11,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          {{ dataLang[foundsList.fund_12?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_12.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_12,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center wp-100">
          {{ dataLang[foundsList.fund_13?.finreestr_funds__name] }}
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_13.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_13,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
      </div>
      <div class="pe-10 flex-grow-1 ps-15 border-end border-disabled">
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          <div v-if="dataLang[foundsList.fund_custom_3?.finreestr_funds__name]">
            {{ dataLang[foundsList.fund_custom_3?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_3?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_3.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_3,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          <div v-if="dataLang[foundsList.fund_custom_4?.finreestr_funds__name]">
            {{ dataLang[foundsList.fund_custom_4?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_4?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_4.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_4,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          <div v-if="dataLang[foundsList.fund_custom_5?.finreestr_funds__name]">
            {{ dataLang[foundsList.fund_custom_5?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_5?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_5.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_5,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          <div v-if="dataLang[foundsList.fund_custom_6?.finreestr_funds__name]">
            {{ dataLang[foundsList.fund_custom_6?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_6?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_6.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_6,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center wp-100">
          <div v-if="dataLang[foundsList.fund_custom_7?.finreestr_funds__name]">
            {{ dataLang[foundsList.fund_custom_7?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_7?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_7.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_7,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
      </div>
      <div class="pe-10 flex-grow-1 ps-15 border-end border-disabled">
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          <div v-if="dataLang[foundsList.fund_custom_8?.finreestr_funds__name]">
            {{ dataLang[foundsList.fund_custom_8?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_8?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_8.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_8,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          <div v-if="dataLang[foundsList.fund_custom_9?.finreestr_funds__name]">
            {{ dataLang[foundsList.fund_custom_9?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_9?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_9.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_9,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          <div
            v-if="dataLang[foundsList.fund_custom_10?.finreestr_funds__name]"
          >
            {{ dataLang[foundsList.fund_custom_10?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_10?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_10.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_10,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
        >
          <div
            v-if="dataLang[foundsList.fund_custom_11?.finreestr_funds__name]"
          >
            {{ dataLang[foundsList.fund_custom_11?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_11?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_11.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_11,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center wp-100">
          <div
            v-if="dataLang[foundsList.fund_custom_12?.finreestr_funds__name]"
          >
            {{ dataLang[foundsList.fund_custom_12?.finreestr_funds__name] }}
          </div>
          <div v-else>
            {{ foundsList.fund_custom_12?.finreestr_funds__name }}
          </div>
          <div class="d-flex gap-10 align-items-center">
            <div>
              {{ foundsList.fund_custom_12.finreestr_funds__amount }}
            </div>
            <div
              class="payload-button payload-button--consumption"
              @click="
                $modal.show('toMoveCost', {
                  datas: foundsList.fund_custom_12,
                  type: 'spend',
                })
              "
            ></div>
          </div>
        </div>
      </div>
      <div
        class="d-flex flex-column justify-content-center gap-10 ps-15"
        style="width: 117px"
      >
        <div class="fsc-12">{{ dataLang["reg_fin_text_33"] }}</div>
        <div class="fsc-16">{{ fullSum }}</div>
      </div>
    </div> -->
    <div class="tw-relative tw-mx-[26px] tw-h-full" style="min-height: 250px">
      <BaseLoader v-if="localLoading"></BaseLoader>
      <div class="tw-flex tw-justify-between tw-py-[15px]">
        <div class="tw-flex">
          <button @click="loadData" class="tw-app-btn-primary-outline">
            {{ dataLang["register_btn_filter_on"] }}
          </button>
          <button
            @click="resetFilter"
            class="tw-app-btn-light !tw-text-[#0056AF]"
          >
            {{ dataLang["register_btn_filter_off"] }}
          </button>
        </div>
        <TwBasePagination
          :page-count="numPages"
          :pagination-params="paginationFinesStateParams"
          :showLimitInput="false"
          :page-range="10"
          :margin-pages="0"
          :break-view-class="''"
          :click-handler="loadData"
          :prev-text="''"
          :next-text="''"
        >
        </TwBasePagination>
      </div>

      <div class="overflow-auto_" style="min-height: 400px">
        <ve-table
          class="fixed-header rest-style-table"
          style="width: 100%"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          row-key-field-name="finreestr__id"
          ref="mainTable"
          :eventCustomOption="eventCustomOption"
          v-if="!localLoading"
          :cell-style-option="cellStyleOption"
          :checkbox-option="{
            selectedRowChange: selectedRowChange,
            selectedAllChange: selectedAllChange,
            hideSelectAll: false,
          }"
          :clickHighlight="false"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
        >
        </ve-table>
      </div>
    </div>

    <BaseModal
      name="pincode"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen="openPin"
      height="auto"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-pt-[38px] tw-px-[30px] tw-pb-[48px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('pincode')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-text-[23px] tw-mb-[15px]">Внимание!</div>
          <div class="tw-my-[15px]">Введите пароль администратора!</div>

          <BaseInputNew
            inputClass="tw-app-input-type-3"
            @input="(data) => (pincode = data.value)"
          >
          </BaseInputNew>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('pincode')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="() => (pincode ? acceptNext() : '')"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["vehile_modal_btn_save"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="deleteRow"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen="({ params }) => (typePin = params.type)"
      @beforeClose="
        () => {
          (typePin = ''), (pincode = '');
        }
      "
      height="auto"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('deleteRow')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-text-[23px] tw-mb-[15px]">
            {{ dataLang["reg_fin_text_63"] }}
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('deleteRow')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reg_fin_text_65"] }}
            </button>
            <button
              @click="deleteRow"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reg_fin_text_64"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <!--  -->

    <FinreestrMoveModal />

    <!--
      это было перенесено в шапку, потому что потребовалась кнопка в шапке
      <WithdrawalOfFundsModal />
    -->
    <BaseModal
      name="zprosIsDone"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="295"
      classes="bg-transparent shadow-none"
    >
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('zprosIsDone')"
          ></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="fw-bold mb-30 text-center">Запрос отправлен</p>

          <div class="d-flex flex-column align-items-center">
            <div class="d-flex justify-content-end gap-15">
              <div
                @click="$modal.hide('zprosIsDone')"
                class="btn btn-sm btn-opposite px-20 rounded-10 d-flex align-items-center justify-content-center"
              >
                {{ dataLang["notification_page_text12"] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="assigneUserSpend"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="295"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('assigneUserSpend')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["reg_fin_text_157"] }}
          </div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('assigneUserSpend')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import httpInstance from "@/http-common";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import FinreestrMoveModal from "./finreestr-modals/FinreestrMoveModal.vue";
// import WithdrawalOfFundsModal from "./finreestr-modals/WithdrawalOfFundsModal.vue";
import FirstColumn from "@/components/finreestr/FirstColumn.vue";
import SecondColumn from "@/components/finreestr/SecondColumn.vue";
import EventBus from "@/event-bus";
import { debounce } from "lodash";

export default {
  components: {
    VeTable,
    VueTabs,
    VTab,
    FinreestrMoveModal,
    // WithdrawalOfFundsModal,
    FirstColumn,
    SecondColumn,
  },

  data() {
    return {
      searchType: undefined,
      listPaymentMethods: [
        { label: "BankCard", value: "BankCard" },
        { label: "SPB", value: "SPB" },
      ],
      valueMethods: {},
      typePin: "",
      fullSum: 0,
      callbackForSum: () => {},
      summForPayment: 0,
      summForPaymentWithPercent: 0,
      foundsList: {},
      localLoading: true,
      statisticsFromMainRequest: {},
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      filters: {},
      activateTab: "",
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      selectTimeTopFilter: {
        dateCreatedStart: [],
        dateCreatedEnd: [],
      },
      activePagePagination: {},
      pincode: "",
      dataForModal: {},
      aboutPageInfo: null,
      dataOfErrors: null,
      senderSmsPreset: null,
      peremText: "",
      typeOpenCancel: "",
      codeFromSms: "",
      selectsDataForModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: [],
      },
      selectsFromModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: [],
      },
      selectsData: {
        typeOfPayment: [],
        typeOrder: [],
        typeObjects: [],
      },
      selectsFilter: {
        typeOfPayment: [],
        typeOrder: [],
        typeObjects: [],
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.$modal.show("contractsModal", {
                contracts__id: row.contracts__id,
              });
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (column.field == "finreestr__amount") {
            return row?.finreestr__type;
          }
        },
      },
    };
  },
  methods: {
    disabledFutureDates(date) {
      return date > new Date();
    },
    async loadFile() {
      let dataFrom = await httpInstance.get("/finreestr/download/file1", {
        responseType: "blob",
      });
      const filename = new Date().toISOString();
      const url = window.URL.createObjectURL(dataFrom.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },

    onAddBalance() {
      let API_PATH = "";
      switch (process.env.VUE_APP_MODE_BUILD) {
        case "production":
          API_PATH = `https://crmrent.com`;
          break;
        case "testing":
          API_PATH = `https://crmtest.ru`;
          break;
        case "development":
          API_PATH = `http://sirius.development`;
          break;
        case "serve-hmr":
          API_PATH = `http://sirius.development`;
          break;
      }
      if (this.summForPayment) {
        GeneralService.get(`/whoami`)
          .then((data) => {
            GeneralService.editOrCreate(
              `/companies/${data.data.data.company_lc}/balance/up`,
              {
                amount: this.summForPayment,
                return_url: `${API_PATH}/finreestr`,
                payment_method: this.valueMethods.value,
              }
            )
              .then((data) => {
                window.location.href = data.data.data.url;
              })
              .catch((e) => {
                this.$toast.error(e.response.data.message, { duration: 5000 });
              });
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          });

        // GeneralService.get(`/companies/${this.userSetting}/balance/up`)
        //   .then((data) => {
        //     this.summForPaymentWithPercent = data.data.data.price
        //   })
        //   .catch((e) => {
        //     this.$toast.error(e.response.data.message, {duration: 5000})
        //   })
      }
    },

    openPin(data) {
      // this.typePin = params.types
    },

    acceptNext() {
      if (this.typePin == "delete") {
        this.$modal.show("deleteRow");
      } else {
        this.loadExel(`/finreestr/table/xlsx?pincode=${this.pincode}`, "xlsx");
      }
    },

    deleteRow() {
      GeneralService.delete(
        `/finreestr/${this.activeSelectRowsMultiple}?pincode=${this.pincode}`
      )
        .then((data) => {})
        .catch((e) => {
          this.activeSelectRowsMultiple = [];
          this.$toast.error(e.response.data.message, { duration: 5000 });
        })
        .finally(() => {
          this.activeSelectRowsMultiple = [];
          this.typePin = "";
          this.pincode = "";
          this.$modal.hide("deleteRow");
          this.$modal.hide("pincode");
          this.loadData();
        });
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },

    async loadStaticDocument() {
      const base = (process.env.BASE_URL || "/").replace(/\/[^/]*$/, "/");
      const url = `${base}docs/findir_sirius.xlsx`;

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("File not found");
        }

        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "findir_sirius.xlsx";
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        this.$toast.error("Не удалось скачать файл", { duration: 5000 });
      }
    },

    async loadExel(urlToFetch, ext) {
      try {
        let dataFrom = await httpInstance.get(urlToFetch, {
          responseType: "blob",
          params: {
            ...this.paginationFinesStateParams,
            where: JSON.stringify([
              ...this.filter,
              this.computedFilterDateSelect(),
            ]),
          },
        });
        const filename = new Date().toISOString();
        const url = window.URL.createObjectURL(dataFrom.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.${ext}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        this.pincode = "";
        this.$modal.hide("pincode");
        this.loadData();
      } catch (e) {}
    },

    saveEditModal() {
      GeneralService.edit(`/trackers/${this.dataForModal.gps__id}`, {
        ...this.updatedValues,
      })
        .then((data) => {
          this.$modal.hide("editTracker");
          this.loadData();
        })
        .catch((e) => {
          this.selectsFromModal.owners = [];
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },

    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.$refs.topFilter
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.filter = [];
      this.filters = {};

      const today = new Date();

      // Рассчитываем смещение до понедельника:
      // - Если сегодня воскресенье (0), отнимаем 6 дней
      // - Для остальных дней: текущий день недели - 1
      const dayOffset = today.getDay() === 0 ? 6 : today.getDay() - 1;

      // Создаем копию текущей даты и вычитаем рассчитанное смещение
      const monday = new Date(today);
      monday.setDate(today.getDate() - dayOffset);

      // Опционально: устанавливаем время на 00:00:00
      monday.setHours(0, 0, 0, 0);

      this.selectTimeTopFilter.dateCreatedStart = this.$time(monday).format(
        `${this.userSetting.company__tempalte_date}`
      );
      this.selectTimeTopFilter.dateCreatedEnd = this.$time().format(
        `${this.userSetting.company__tempalte_date}`
      );
      this.selectsFilter.trackers = [];
      this.selectsFilter.statuses = [];
      this.selectsFilter.typeOfPayment = [];
      this.filterTimes = {
        contractsCreateStart: "",
        contractsCreateEnd: "",
        startsRateTime: "",
        endRateTime: "",
        startsRateFinishTime: "",
        endRateFinishTime: "",
      };
      this.loadData();
    },

    onCloseModal() {
      this.currentId = null;
      this.updatedValues = {};
      this.dataForModal = {};
      this.activeSelectRowsMultiple = [];
      this.selectsFromModal.objectsVehicle = [];
      this.selectsFromModal.typeVehicles = [];
    },
    deleteActionAndModal() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptDelete");
      } else {
        this.$modal.show("withoutOptionsModal");
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
    },
    computedFilterDateSelect() {
      if (
        this.selectTimeTopFilter.dateCreatedStart.length &&
        this.selectTimeTopFilter.dateCreatedEnd.length
      ) {
        let start = this.selectTimeTopFilter.dateCreatedStart.split(" ");
        let end = this.selectTimeTopFilter.dateCreatedEnd.split(" ");
        return {
          field: "finreestr__created_at",
          value: [
            start[0].split(".").reverse().join("-") + " " + "00:00",
            end[0].split(".").reverse().join("-") + " " + "23:59",
          ],
          operator: "between",
        };
      } else {
        return {
          field: "finreestr__created_at",
          value: [],
          operator: "between",
          mod: "dateUTCLastMonday",
        };
      }
    },
    loadData(callback) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(
          `/finreestr/table?uniqueBy=finreestr_funds__id&fields=finreestr_funds__id,finreestr_funds__name`
        )
          .then((data) => {
            this.selectsData.typeOfPayment = data.data.data.rows;
          })
          .catch((e) => {
            this.$toast.error("Ошибка", { duration: 5000 });
          }),
        GeneralService.get(`/finreestr-funds`)
          .then((data) => {
            data.data.data.rows.forEach((item, index) => {
              this.foundsList[item.finreestr_funds__code] = item;
            });
            this.fullSum = data.data.data.itogSum;
          })
          .catch((e) => {
            this.$toast.error("Ошибка", { duration: 5000 });
          }),

        // /finreestr-funds?where=[{"field":"finreestr_funds__is_coming","value":1}]&fields=finreestr_funds__id,finreestr_funds__name,finreestr_funds__is_coming
      ]).then(() => {
        // формирование поискового запроса для определенного типа поиска
        // searchType=true - по дате
        // searchType=false - по id
        // searchType=undefined - по дате и id
        let searchWhere;
        if (this.searchType === undefined) {
          searchWhere = JSON.stringify([
            ...this.filter,
            this.computedFilterDateSelect(),
          ]);
        }
        if (this.searchType)
          searchWhere = JSON.stringify([this.computedFilterDateSelect()]);
        if (!this.searchType) searchWhere = JSON.stringify([...this.filter]);
        this.searchType = undefined;
        // формирование поискового запроса для определенного типа поиска
        GeneralService.get(`/finreestr/table`, {
          params: {
            ...this.paginationFinesStateParams,
            where: searchWhere,
          },
        })
          .then((data) => {
            this.dataTable = data.data.data.rows;
            this.getFinesAll(data.data.data);
            this.aboutPageInfo = {
              sumExpenses: data.data.data.sumExpenses,
              sumReceipts: data.data.data.sumReceipts,
            };
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    fillFilter(data) {
      this.$set(this.filters, data.name, data.value);
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },

    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    EventBus.$on("updateModalsFin", () => {
      this.loadData();
    });
    this.valueMethods = this.listPaymentMethods[1];

    this.callbackForSum = debounce((data) => {
      this.summForPayment = data.value;
      GeneralService.get(
        `/payment/calc-price?amount=${data.value}&payment_method=${this.valueMethods.value}`
      )
        .then((data) => {
          this.summForPaymentWithPercent = data.data.data.price;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    }, 200);

    const today = new Date();
    const dayOffset = today.getDay() === 0 ? 6 : today.getDay() - 1;

    // Создаем копию текущей даты и вычитаем рассчитанное смещение
    const monday = new Date(today);
    monday.setDate(today.getDate() - dayOffset);

    // Опционально: устанавливаем время на 00:00:00
    monday.setHours(0, 0, 0, 0);

    const formatter = new Intl.DateTimeFormat("ru", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });

    this.selectTimeTopFilter.dateCreatedStart = formatter.format(monday);

    this.selectTimeTopFilter.dateCreatedEnd = formatter.format(new Date());

    this.loadData();
  },
  beforeMount() {},
  created() {},
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),

    optionsFirstCol() {
      return [
        this.foundsList.fund_3,
        this.foundsList.fund_2,
        this.foundsList.fund_custom_1,
        this.foundsList.fund_custom_2,
        this.foundsList.fund_1,
      ];
    },
    optionsTwoCol() {
      return [
        this.foundsList.fund_4,
        this.foundsList.fund_5,
        this.foundsList.fund_6,
        this.foundsList.fund_7,
        this.foundsList.fund_8,
      ];
    },
    optionsThreeCol() {
      return [
        this.foundsList.fund_9,
        this.foundsList.fund_10,
        this.foundsList.fund_11,
        this.foundsList.fund_12,
        this.foundsList.fund_13,
      ];
    },
    optionsFourCol() {
      return [
        this.foundsList.fund_custom_3,
        this.foundsList.fund_custom_4,
        this.foundsList.fund_custom_5,
        this.foundsList.fund_custom_6,
        this.foundsList.fund_custom_7,
      ];
    },
    optionsFiveCol() {
      return [
        this.foundsList.fund_custom_8,
        this.foundsList.fund_custom_9,
        this.foundsList.fund_custom_10,
        this.foundsList.fund_custom_11,
        this.foundsList.fund_custom_12,
      ];
    },

    columns() {
      return [
        {
          field: "",
          key: "a62",
          type: "checkbox",
          title: "",
          width: "2%",
          align: "center",
        },
        {
          field: "finreestr__id",
          key: "162336",
          title: "ID",
          align: "start",
          width: "7%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "finreestr__created_at",
          key: "16336",
          title: this.dataLang["reg_fin_text_45"],
          align: "start",
          width: "7%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.finreestr__created_at
                  ? this.$time(row.finreestr__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "finreestr__amount",
          key: "136326",
          title: this.dataLang["reg_fin_text_46"],
          align: "start",
          width: "7%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },

          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div style={"height: 20px"}></div>
                <div>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onKeyupEnter={this.loadData}
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"finreestr__amount"}
                  value={this.filters.finreestr__amount}
                  nameSign={""}
                />
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.finreestr__direction}
                {row.finreestr__amount?.split(".")?.join(",")}
              </span>
            );
          },
        },
        {
          field: "finreestr_funds__name",
          key: "162136",
          title: this.dataLang["reg_fin_text_47"],
          align: "start",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {this.dataLang[row.finreestr_funds__name] ??
                  row.finreestr_funds__name}
              </span>
            );
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div style={"height: 20px"}></div>
                <div>{this.dataLang[column.title] ?? column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.typeOfPayment}
                  onInput={(e, w) => {
                    if (
                      !this.filter.find((x) => x.field == "finreestr_funds__id")
                    ) {
                      this.filter.push({
                        field: "finreestr_funds__id",
                        value: e.finreestr_funds__id,
                      });
                    } else {
                      this.filter[
                        this.filter.findIndex(
                          (x) => x.field == "finreestr_funds__id"
                        )
                      ].value = e.finreestr_funds__id;
                    }
                  }}
                  style={"width: 100%"}
                  customLabel={({ finreestr_funds__name }) =>
                    this.dataLang[finreestr_funds__name]
                  }
                  placeholder={""}
                  id={"id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={this.selectsData.typeOfPayment}
                  onSelect={this.loadData}
                ></BaseSelect>
              </div>
            );
          },
        },
        {
          field: "finreestr__contragent",
          key: "172551",
          title: this.dataLang["reg_fin_text_48"],
          align: "start",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div style={"height: 20px"}></div>
                <div>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onKeyupEnter={this.loadData}
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"finreestr__contragent"}
                  value={this.filters.finreestr__contragent}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "finreestr__basis",
          key: "166136",
          title: this.dataLang["reg_fin_text_49"],
          align: "start",
          width: "35%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div style={"height: 20px"}></div>
                <div>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onKeyupEnter={this.loadData}
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"finreestr__basis"}
                  value={this.filters.finreestr__basis}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "finreestr__manager",
          key: "1286136",
          title: this.dataLang["reg_fin_text_51"],
          align: "start",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div style={"height: 20px"}></div>
                <div>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onKeyupEnter={this.loadData}
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"finreestr__manager"}
                  value={this.filters.finreestr__manager}
                  nameSign={""}
                />
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.payload-button {
  display: flex;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;

  &--consumption {
    border-radius: 3px;
    box-shadow: 0px 7px 2px 0px #00000000;
    background-color: rgb(223, 222, 222);

    &:before {
      content: "";
      background-color: #ff2400;
      width: 7px;
      height: 1.5px;
      display: block;
      margin: auto;
    }
  }

  &--move {
    background-color: #0d63ab;
    border-radius: 3px;

    img {
      margin: auto;
    }
  }

  &--top {
    background-color: #8000ff;
    border-radius: 3px;

    img {
      margin: auto;
    }
  }

  &--add {
    background-color: #f6ee25;
    border-radius: 3px;

    img {
      margin: auto;
    }
  }
}

.top-line-custom {
  position: absolute;
  display: flex;
  justify-content: space-between;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: white;
  width: 65%;
}
</style>
